import React, { useEffect, useRef, useState } from 'react'
import { FiUpload } from 'react-icons/fi'
import { FiTrash2 } from 'react-icons/fi'
import '../../assets/css/components/Inputs/InputUpload.css'
import placeholder from '../../assets/images/img-placeholder.jpg'
import uniqueId from 'lodash/uniqueId'
import useSnackBars from '../../hooks/SnackbarConsumerHook'

const InputUpload: React.FC<InputUploadProps> = ({
  name,
  value,
  buttonLabel,
  fileType,
  handleImage,
  deleteImage,
  containerClasses,
  imageClasses,
  title = '',
  maxHeight = "max-h-44",
  size = 1093957,
  isCompressed = false,
  ...props
}) => {
  const [image, setImage] = useState<any>(value || '')
  const fileInput = useRef<HTMLInputElement>(null)
  const defaultName = 'defaultInput'
  const randomId = uniqueId('label-')
  const { addAlert } = useSnackBars()

  const [windowSize, setWindowSize] = useState(getWindowSize())

  useEffect(() => {
    function handleWindowResize() {
      setWindowSize(getWindowSize())
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [])

  function getWindowSize() {
    const { innerWidth, innerHeight } = window
    return { innerWidth, innerHeight }
  }

  const handleFile = (e) => {
    e.preventDefault()

    if (isCompressed) { 
      console.log("LLEGANDO")
      if (fileInput.current?.files && fileInput.current?.files[0]) {
        if (fileInput.current?.files[0].type === 'image/jpeg' || fileInput.current?.files[0].type === 'image/png' || fileInput.current?.files[0].type === 'image/jpg') {
          
          console.log("LLEGANDI")
          const file = fileInput.current.files[0]
          const maxSize = 5 * 1024 * 1024 // 5MB en bytes
          const maxWidth = 1000
          const maxHeight = 1000

          // Función para comprimir imagen
          const compressImage = (file: File): Promise<File> => {
            return new Promise((resolve) => {
              const reader = new FileReader()
              reader.onload = (event) => {
                const img = new Image()
                img.onload = () => {
                  const canvas = document.createElement('canvas')
                  const ctx = canvas.getContext('2d')
                  
                  // Calcular nuevas dimensiones manteniendo proporción
                  let { width, height } = img
                  if (width > maxWidth || height > maxHeight) {
                    const ratio = Math.min(maxWidth / width, maxHeight / height)
                    width = width * ratio
                    height = height * ratio
                  }
                  
                  canvas.width = width
                  canvas.height = height
                  
                  // Dibujar imagen redimensionada
                  ctx?.drawImage(img, 0, 0, width, height)
                  
                  // Convertir a blob con calidad ajustable
                  canvas.toBlob((blob) => {
                    if (blob) {
                      // Si el blob es mayor a 5MB, reducir calidad
                      if (blob.size > maxSize) {
                        canvas.toBlob((compressedBlob) => {
                          if (compressedBlob) {
                            const compressedFile = new File([compressedBlob], file.name, {
                              type: file.type,
                              lastModified: Date.now()
                            })
                            resolve(compressedFile)
                          }
                        }, file.type, 0.7) // Reducir calidad a 70%
                      } else {
                        const compressedFile = new File([blob], file.name, {
                          type: file.type,
                          lastModified: Date.now()
                        })
                        resolve(compressedFile)
                      }
                    }
                  }, file.type, 0.9) // Calidad inicial 90%
                }
                img.src = event.target?.result as string
              }
              reader.readAsDataURL(file)
            })
          }

          // Procesar la imagen
          compressImage(file).then((compressedFile) => {
            if (handleImage) handleImage(compressedFile)
            
            const reader = new FileReader()
            reader.onload = (ev: any) => {
              if (ev && ev.target) {
                setImage(ev.target.result)
              } else {
                setImage('')
              }
            }
            reader.readAsDataURL(compressedFile)
          }).catch((error) => {
            console.error('Error al comprimir imagen:', error)
            addAlert({
              message: 'Error al procesar la imagen',
              status: 'error',
            })
          })
          
        } else {
          addAlert({
            message: 'Debes subir una imagen con extensión jpeg, jpg o png',
            status: 'error',
          })
        }
      }
      return
    }

    if (fileInput.current?.files && fileInput.current?.files[0]) {
      if (fileInput.current?.files[0].type === 'image/jpeg' || fileInput.current?.files[0].type === 'image/png' || fileInput.current?.files[0].type === 'image/jpg') {
        // console.log("ver...", fileInput.current?.files[0])
        //@ts-ignore
        // console.log("img...", fileInput.current?.naturalHeight)
        // console.log("img...", fileInput.current?.width)
        if (fileInput.current?.files[0].size > size) {
  
          addAlert({
            message: 'La imagen debe de ser menor a 1mb',
            status: 'error',
          })
        } else {
          const reader = new FileReader()
          if (handleImage) handleImage(fileInput.current.files[0])
          reader.onload = (ev : any) => {
            console.log("Ver ev", ev)
              let img = new Image()
              img.src = ev?.target?.result
              setTimeout(() => {
                console.log("img", img.height)
                console.log("llegannn", img?.width)
  
                let height = img?.height
                let width = img?.width
  
                if (height > 1200 || width > 1200) {
                  addAlert({
                    message: 'La imagen debe de ser máximo de 1200x1200',
                    status: 'error',
                  })
                  return 
                }
  
  
                if (ev && ev.target) {
                  setImage(ev.target.result)
                } else setImage('')
  
              }, 200)
              // image.onload = () => {
              //   console.log(image.width, image.height);
              // };
            
          }
          reader.readAsDataURL(fileInput.current?.files[0])
        }
      } else {
        addAlert({
          message: 'Debes subir una imagen con extensión jpeg, jpg o png',
          status: 'error',
        })
      }
    } 
  }

  const deleteFile = (e) => {
    console.log(e)
    e.preventDefault()
    setImage('')
    if (deleteImage) deleteImage()
  }

  return (
    <div className={`relative ${containerClasses}`}>
      {/* <div>{label}</div> */}
      <div className={`relative ${maxHeight}`} style={{maxWidth: '16rem'}}>
        {image !== '' ? (
          <img
            src={image}
            alt="imageUpload"
            className={`${maxHeight} object-contain ${imageClasses}`}
          />
        ) : (
          <img
            src={placeholder}
            alt="imageUpload"
            className={`${maxHeight} object-contain ${imageClasses}`}
          />
        )}

        {image === '' && (
          <label className='absolute text-xs text-center w-full' style={{ top: '70%'}}>{title}</label>
        ) }
          

        <div
          className="absolute flex justify-end"
          style={{ top: '5%', right: '5%' }}
        >

          <div className='flex justify-end'>

          </div>
          <label
            htmlFor={randomId}
            className="cursor-pointer mr-2 bg-gray-200 border-2 border-gray-200 hover:text-primary hover:border-primary-600 dark:text-black dark:hover:text-primary dark:hover:border-primary-600 rounded-lg"
          >
            <FiUpload
              className="mx-auto text-primary"
              style={{ width: '80%', marginTop: '18%' }}
              size={22}
            />
          </label>

          <label
            htmlFor={randomId}
            onClick={(e) => deleteFile(e)}
            className="cursor-pointer bg-gray-200 border-2 hover:text-red-600 hover:border-red-600 border-gray-200 dark:text-black dark:hover:text-red-600 dark:hover:border-red-600 rounded-lg"
          >
            <FiTrash2
              className="mx-auto text-primary"
              style={{ width: '80%', marginTop: '18%' }}
              size={22}
            />

          </label>
        </div>

      </div>

      {/* <Button type="primary" htmlType="button" classes="relative" icon={<BiPlus/>} >{buttonLabel || 'Subir archivo'}<label className="abs-label" htmlFor={randomId}></label></Button> */}
      {/* <label
        htmlFor={randomId}
        className="cursor-pointer absolute bg-gray-200 border-2 border-gray-200 hover:text-primary hover:border-primary-600 dark:text-black dark:hover:text-primary dark:hover:border-primary-600 rounded-lg"
        style={{ top: '6%', right: '27%', width: '17%', height: '17%' }}
      >
        <FiUpload
          className="mx-auto text-primary"
          style={{ width: '80%', marginTop: '18%' }}
          size={22}
        />
      </label>
      <label
        htmlFor={randomId}
        onClick={(e) => deleteFile(e)}
        className="cursor-pointer absolute bg-gray-200 border-2 hover:text-red-600 hover:border-red-600 border-gray-200 dark:text-black dark:hover:text-red-600 dark:hover:border-red-600 rounded-lg"
        style={{ top: '6%', right: '6%', width: '17%', height: '17%' }}
      >
        <FiTrash2
          className="mx-auto text-primary"
          style={{ width: '80%', marginTop: '18%' }}
          size={22}
        />
      </label> */}

      {/* {image !== '' &&
      <Button type="primary" htmlType="button" danger={true} icon={<BiTrash/>} classes="ml-2 relative" onClick={(e) => deleteFile(e)}>Borrar<label className="abs-label"></label></Button>
    } */}



      <input
        id={randomId}
        name={name ? name : defaultName}
        ref={fileInput}
        type="file"
        accept={fileType === 'image' ? 'image/*' : '*'}
        onChange={handleFile}
        onLoad={(image) => {
          //@ts-ignore
          // console.log("image", image?.)
        }}
        {...props}
      />
    </div>
  )
}

export default InputUpload

type InputProps = JSX.IntrinsicElements['input']

interface InputUploadProps extends InputProps {
  fileType?: 'image'
  buttonLabel?: string
  handleImage?: Function
  deleteImage?: Function
  containerClasses?: string
  imageClasses?: string
  title?: string
  maxHeight?: string
  size?: number
  isCompressed?: boolean
}
